@if (hasScore || level) {
<div class="kyb-risk-badge" [ngClass]="levelClass()" [matTooltip]="level || 'Risk score'">
  @if (hasScore || !level) {
  <span class="score-circle">{{ displayScore }}</span>
  }
  @if (level) {
  <span class="level-label">{{ level }}</span>
  }
</div>
}
